module.exports = __webpack_public_path__ + "resources/img/img_appguard2.b2311e1b5ef8b58bdc116bf179c1c6b8.png";